import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Store } from '@ngrx/store';

import { CONFIG, cripKey } from '../../../config';
import { AppState } from '../../../store/app-state';
import {
  mainStartLoadingAction,
  mainStopLoadingAction
} from '../../../store/main/index';


@Injectable()
export class ApiService {
  public config;

  
  

  constructor(private store: Store<AppState>, private http: Http) {
    this.config = CONFIG;
    
  }




  sendSat(url: string, payload: any = {}, type: string) {
    const headers = new Headers({
      //'Content-Type': 'application/x-www-form-urlencoded'
    });
    if(type = "post")
    {
      return this.http
      .post(CONFIG.url_SAT + url, payload, { headers })
      .map(result => result.json())
      .toPromise()
      .then(result => {
        this.store.dispatch(mainStopLoadingAction());
        return result;
      })
      .catch(error => {
        this.store.dispatch(mainStopLoadingAction());
        return error;
      });

    }

  }

  

  send(url: string, payload: any = {}) {
    
    //this.store.dispatch(mainStartLoadingAction());
    return this.http
      .post(CONFIG.url + url, payload)
      .map(result => result.json())
      .toPromise()
      .then(result => {
        this.store.dispatch(mainStopLoadingAction());
        if (result.valid) {
          return result.object;
        }
      })
      .catch(error => {
        this.store.dispatch(mainStopLoadingAction());
        const result = JSON.parse(error._body);
        result.error.forEach(item => {
          console.error(item.exception);
        });
      });
  }

  sendSub(url: string, payload: any = {}) {
    return this.http
      .post(CONFIG.url + url, payload)
      .map(result => result.json());
  }

  sendV2(url: string, payload: any = {}) {
    this.store.dispatch(mainStartLoadingAction());
    return this.http
      .post(CONFIG.url + url, payload)
      .map(result => result.json())
      .toPromise()
      .then(result => {
        this.store.dispatch(mainStopLoadingAction());
        return result;
      })
      .catch(error => {
        this.store.dispatch(mainStopLoadingAction());
        const result = JSON.parse(error._body);
        result.error.forEach(item => {
          console.error(item.exception);
          return item;
        });
      });
  }

  getCatalogue(url: string) {
    this.store.dispatch(mainStartLoadingAction());
    return this.http
      .get(CONFIG.url + url)
      .map(result => result.json())
      .toPromise()
      .then(result => {
        this.store.dispatch(mainStopLoadingAction());
        if (result.valid) {
          return result.object;
        }
      })
      .catch(error => {
        this.store.dispatch(mainStopLoadingAction());
      });
  }

  authenticate(payload: any) {
    /*var CryptoJS = require("crypto-js");
    var key = CryptoJS.enc.Utf8.parse("8080808080808080");
    var iv = CryptoJS.enc.Utf8.parse("8080808080808080");

    payload.email = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(payload.email), key,
    {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    }).toString();

    payload.password = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(payload.password), key,
    {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    }).toString();
    */

    this.store.dispatch(mainStartLoadingAction());
    const headers = new Headers({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    const credentials =
      'username=' +
      payload.email +
      '&password=' +
      payload.password +
      '&grant_type=password';
    return this.http
      .post(CONFIG.url_token, credentials, { headers })
      .map(result => result.json())
      .toPromise()
      .then(result => {
        this.store.dispatch(mainStopLoadingAction());
        return result;
      })
      .catch(error => {
        this.store.dispatch(mainStopLoadingAction());
        const result = JSON.parse(error._body);
        /*result.error.forEach(item => {
          console.error(item.error);
        });*/
        return result;
      });
  }

  fillPostalCode(postalcode: string)
  {
    var x = postalcode.toString().length;
    if(x < 5)
    {
      for (let i = x; i < 5; i++) 
      {
        postalcode = "0" + postalcode;
      }
    }
    return postalcode;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/service/core/api.service.ts